import {
  getmoble,
  memberImproveRecords,
  getSellerCheckCode,
  changeStatus,
  exportRecord,
  expotrPromoSendReBuy,
  expotrPromoSendReBuytokenRecord,
  benchmarkingExport,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { searchInvite } from "@/api/integralCenter/integralTask";
import echarts from "echarts";
import {
  checkRecord,
  getCouponData,
  getCouponTable,
  checkList,
  awardRecord,
  awardRecNew,
  inKindList,
  exportRecNew,
  improveList,
  signIssuance,
  getShopGiftParticipateConver,
  getSplitCouponlist,
  getStatisticsCouponlist,
  CouponDetail,
  CouponDetailmember,
  sendSampleRecordExportOne,
  CouponDetailID,
  commentDraw,
  getExportCode,
  getExportxlxs,
  getExportLockRight,
  getExportLockWin,
  participation,
  gameTaskRecord,
  markDeliveryStatus,
  DeliveryStatus,
  markingSendStatus,
  getActivityRuleFields,
  getSumEffectDetailsV1,
  getChartEffectChartV1,
  getSmartDataDetail,
  getSmartDataSum,
  getExchangeActivityRecord,
  splitCouponPage,
  splitCouponGroup,
  splitCouponStatistics,
  groupMember,
  getSumEffectOne,
  getDetailIncludeTotalOne,
  getDetailEffectOne,
  getGoodRecords,
  awardRecNewOne,
  invaidStatics,
  invitationDetailNew,
  addCartpage,
  lockRightRecord,
  lockWinRecord,
  addCartDetail,
  getSumLockEffectJi,
  getDetailLockEffectJi,
  exportJi,
  getDataOverview,
  getDetailPage,
  getExport,
  getWinRecordPage,
  getUnlockRecord,
  exportCheckOrderDetail,
  exportExchangeActivityRecord,
  getGoodsRecordPage,
  winRecordExport,
  goodsRecordExport,
  getOrderRecordPage,
  orderRecordPageExport,
  getSumEffect,
  getDetailEffect,
  getDetailIncludeTotal,
  sendSampleRecordExport,
  pointActivityEffectDetailsExport,
  exportPointInviteCardActivityPrize,
  exportPointActivityPrizeDetailForPurchase,
  exportPointActivityPrizeDetail,
  promoPage,
  promoPageToken,
  benchmarking,
  getInviteDetail,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController2";
import { goodRecords } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { querySellerSetting } from "@/api/jhk/userInform";
import {
  getUserProfileList,
  getUserProfileStatic,
  exportUserProfile,
} from "@/api/jhk/integralCenter/politely";

var pins = "";
export default {
  methods: {
    handleDeleteTable() {
      this.outerVisible = false;
    },
    // 查看加购详情
    checkCartDetail(row) {
      addCartDetail(row.id)
        .then((res) => {
          this.addCartDetailShow = true;
          this.addCartDetailData = res.data;
        })
        .catch((res) => {});
    },
    invitationDeatils(val) {
      pins = val.pin;
      this.dialogDeatils = true;
      this.formList1.size = 10;
      this.formList1.current = 1;
      if (this.isTaskPrize) {
        this.taskIndex = val.taskIndex;
      }
      this.invitationDetailNews();
    },
    invitationDetailNews() {
      this.loading1 = true;
      let params = {
        ...this.formList,
      };
      params.pin = pins;
      params.size = this.formList1.size;
      params.current = this.formList1.current;
      if (this.isTaskPrize) {
        params.taskIndex = this.taskIndex;
      }
      invitationDetailNew(params).then((res) => {
        this.loading1 = false;
        this.CouponMember1 = res.data.records;
        this.totalNum = Number(res.data.total);
      });
    },
    batchMark(source) {
      if (this.multipleSelection.length == 0)
        return this.$message.warning("请先勾选有效数据再操作");
      let ids = this.multipleSelection.map((item) => item.id);
      if (this.fitersChooseIF([33])) {
        ids = this.multipleSelection.map((item) => item.recordId);
      }
      if (this.fitersChooseIF([9])) {
        markDeliveryStatus(ids).then((res) => {
          if (res.code == 1) {
            this.getList();
            this.multipleSelection = [];
            this.$message.success(res.message);
          } else {
            this.$message.warning(res.message);
          }
        });
      } else {
        markingSendStatus(source, ids).then((res) => {
          if (res.code == 1) {
            if (this.fitersChooseIF([33])) {
              if (source == 1) this.winningRecord();
            } else {
              if (source == 1) this.inKingRecord();
            }
            if (source == 2) this.winningRecord();
            this.multipleSelection = [];
            this.$message.success(res.message);
          } else {
            this.$message.warning(res.message);
          }
        });
      }
    },
    // 批量标记发货-兑换实物
    batchMark2() {
      this.batchMarkVisible = true;
    },
    // 关闭批量标记发货
    batchMarkClose() {
      this.batchMarkVisible = false;
    },
    // 批量标记发货
    batchMarkForShipment() {
      // if(this.fitersChooseIF([33])) {
      //   ids = this.multipleSelection.map((item) => item.recordId);
      // }
      this.physicalBatchShipmentShow = true;
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出
    export_fun() {
      this.$refs.export_fun_sw.export_fun();
    },
    async export_get(type = 1) {
      if (type == 1) {
        this.control2 = true;
      } else if (type == 2) {
        this.control1 = true;
      } else if (type == 3) {
        this.control3 = true;
      } else if (type == 4) {
        this.control4 = true;
      }
    },
    async getphone(val) {
      this.control4 = true;
    },
    savePhone(type , exportRemark = "") {
      console.log(type);
      if (type == 3) {
        expotrPromoSendReBuytokenRecord({
          ...this.formList,
          exportRemark,
        }).then((res) => {
          if (res.code == 1) {
          } else {
            this.$message.warning(res.message);
          }
        });
      } else if (type == 4) {
        benchmarkingExport({ ...this.formList, exportRemark }).then(
          (res) => {
            if (res.code == 1) {
            } else {
              this.$message.warning(res.message);
            }
          }
        );
      } else {
        expotrPromoSendReBuy({...this.formList,exportRemark}).then((res) => {
          if (res.code == 1) {
          } else {
            this.$message.warning(res.message);
          }
        });
      }
    },
    /** 获取验证码 */
    getCodeInit() {
      if (!this.timer) {
        getSellerCheckCode().then((res) => {
          if (res.code == 1) {
            this.codeDisabled = true;
            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.codeMsg = "重新发送(" + this.countdown + ")";
                } else {
                  clearInterval(this.timer);
                  this.codeMsg = "获取验证码";
                  this.countdown = 60;
                  this.timer = null;
                  this.codeDisabled = false;
                }
              }
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    getCode() {
      // 验证码60秒倒计时
      if (!this.codeDisabled) {
        getExportCode().then((res) => {
          if (res.code == 1) {
            this.codeDisabled = true;
            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.codeMsg = "已发送(" + this.countdown + "s)";
                  // this.successMsg = "验证码错误！"
                } else {
                  clearInterval(this.timer);
                  this.codeMsg = "重新获取";
                  this.countdown = 60;
                  this.timer = null;
                  this.codeDisabled = false;
                }
              }
            }, 1000);
          } else {
            this.successMsg = res.message;
          }
        });
      }
    },
    getApi_Exprot(exportRemark) {
      // 新逻辑 按记录区分导出，因为一种活动 activityType 可能有多种记录需要导出
      if (this.activeName === "eighteen") {
        // 锁权记录
        let obj = this.$refs.export_fun18.export_fun2();
        let params = {
          ...obj,
          activityId: this.formList.activityId,
          code: this.code,
          current: 1,
          size: 9999999,
        };
        this.formLoading = true;
        getExportLockRight(params).then((res) => {
          this.formLoading = false;
          if (res.code == 1) {
            this.successMsg = "";
            this.dialogExprot = false;
            let Time = new Date().toLocaleString();
            let blob = new Blob([res.blob]);
            let link = document.createElement("a"); //a标签下载
            link.href = window.URL.createObjectURL(blob);
            link.download = "锁权记录" + Time + ".xls";
            link.click();
            window.URL.revokeObjectURL(link.href);
            // }
          } else {
            // this.successMsg = res.message;
            this.$message.warning(res.message);
          }
        });
      } else if (this.activeName === "seventeen") {
        // 发货信息
        let obj = this.$refs.export_fun17.export_fun2();
        let params = {
          ...obj,
          activityId: this.formList.activityId,
          code: this.code,
          current: 1,
          size: 9999999,
          isReceiveInfo: true,
        };
        if (this.fitersChooseIF([37])) {
          params.subType = "37";
        }
        this.formLoading = true;
        getExportLockWin(params).then((res) => {
          this.formLoading = false;
          if (res.code == 1) {
            this.successMsg = "";
            this.dialogExprot = false;
            let Time = new Date().toLocaleString();
            let blob = new Blob([res.blob]);
            let link = document.createElement("a"); //a标签下载
            link.href = window.URL.createObjectURL(blob);
            link.download = "收货信息" + Time + ".xls";
            link.click();
            window.URL.revokeObjectURL(link.href);
            // }
          } else {
            // this.successMsg = res.message;
            this.$message.warning(res.message);
          }
        });
      } else if (this.activeName === "sixteen") {
        // 积分锁权-中奖记录
        let obj = this.$refs.export_fun16.export_fun2();
        let params = {
          ...obj,
          activityId: this.formList.activityId,
          code: this.code,
          current: 1,
          size: 9999999,
        };
        if (this.fitersChooseIF([37])) {
          params.subType = "37";
        }
        this.formLoading = true;
        getExportLockWin(params).then((res) => {
          this.formLoading = false;
          if (res.code == 1) {
            this.successMsg = "";
            this.dialogExprot = false;
            let Time = new Date().toLocaleString();
            let blob = new Blob([res.blob]);
            let link = document.createElement("a"); //a标签下载
            link.href = window.URL.createObjectURL(blob);
            link.download = "中奖名单" + Time + ".xls";
            link.click();
            window.URL.revokeObjectURL(link.href);
            // }
          } else {
            // this.successMsg = res.message;
            this.$message.warning(res.message);
          }
        });
      } else if (this.activeName === "first" && this.fitersChooseIF([35])) {
        let tt = "00:00:00",
          tt1 = "23:59:59";
        let params = {
          // startTime = this.postForm.startDate;
          // endTime = this.postForm.endDat
          startTime: this.postForm.startDate || "",
          endTime: this.postForm.endDate || "",
          pin: this.postForm.pin || "",
          activityId: this.formList.activityId,
          code: this.code,
          current: 1,
          size: 9999999,
          channelCode: this.postForm.channelCode,
        };
        if (
          params.startTime.indexOf("00:00:00") != -1 &&
          params.endTime.indexOf("23:59:59") != -1
        ) {
          params.startTime = this.postForm.startDate;
          params.endTime = this.postForm.endDate;
        } else {
          params.startTime = this.postForm.startDate + " 00:00:00";
          params.endTime = this.postForm.endDate + " 23:59:59";
        }
        exportJi(params).then((res) => {
          if (res.code == 1) {
            this.successMsg = "";
            this.dialogExprot = false;
            let Time = new Date().toLocaleString();
            let blob = new Blob([res.blob]);
            let link = document.createElement("a"); //a标签下载
            link.href = window.URL.createObjectURL(blob);
            link.download = "活动统计" + Time + ".xls";
            link.click();
            window.URL.revokeObjectURL(link.href);
          } else {
            this.$message.warning(res.message);
          }
        });
      } else {
        // 旧逻辑 均按活动 activityType 判断
        let params = {
          ...this.ExprotData,
          activityId: this.formList.activityId,
          current: 1,
          size: 9999999,
          exportRemark,
        };
        if (this.fitersChooseIF([37])) {
          params.subType = "37";
        }
        if (this.$route.query.activityType == 33) {
          let obj = this.$refs.export_fun33.export_fun2();
          params = {
            ...obj,
            activityId: this.formList.activityId,
            code: this.code,
            current: 1,
            size: 9999999,
            subType: 33,
          };
        }
        // 生日有礼-实物奖品名单-导出
        if (this.rowData.activityType == 39) {
          params = {
            activityId: this.formList.activityId,
            pin: this.postForm.pin || "",
            current: 1,
            size: 9999999,
            exportRemark,
            subType: 39,
          };
          if (this.formList.memberNick) {
            params.memberNick = this.formList.memberNick;
          }
          if (
            this.formList.deliveryTimeStart &&
            this.formList.deliveryTimeEnd
          ) {
            params.deliveryTimeStart = this.formList.deliveryTimeStart;
            params.deliveryTimeEnd = this.formList.deliveryTimeEnd;
          }
          if (this.formList.sendTimeStart && this.formList.sendTimeEnd) {
            params.sendTimeStart = this.formList.sendTimeStart;
            params.sendTimeEnd = this.formList.sendTimeEnd;
          }
          if (this.formList.status) {
            params.status = this.formList.status;
          }
        }
        getExportxlxs(params).then((res) => {
          if (res.code == 1) {
            this.control2 = true;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 打榜有礼 导出
    getApi_Exprot2(tabName = 1) {
      console.log("tabName", tabName);
      switch (tabName) {
        case 1:
          console.log("活动统计导出");
          let params = {
            activityId: this.formList.activityId,
            code: this.code,
            endTime: this.postForm.endDate || "",
            startTime: this.postForm.startDate || "",
            pin: this.postForm.pin || "",
          };
          if (
            params.startTime.indexOf("00:00:00") != -1 &&
            params.endTime.indexOf("23:59:59") != -1
          ) {
            params.startTime = this.postForm.startDate;
            params.endTime = this.postForm.endDate;
          } else {
            params.startTime = this.postForm.startDate + " 00:00:00";
            params.endTime = this.postForm.endDate + " 23:59:59";
          }
          console.log("参数", params);
          getExport(params)
            .then((res) => {
              console.log("res", res);
              if (res.code == 1) {
                this.dialogExprot = false;
                const href = URL.createObjectURL(res.blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.setAttribute("href", href);
                a.download = res.fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(href);
              } else {
                this.$message.error("导出失败");
              }
            })
            .catch(() => {
              this.$message.error(res.code);
            });
          break;
        case 2:
          console.log("领奖记录导出");
          // 查询列表
          let formObj2 = this.$refs.export_fun_lj2.export_fun2();
          let pamams2 = {
            ...formObj2,
            id: this.formList.activityId,
            code: this.code,
          };
          console.log("参数", pamams2);
          winRecordExport(pamams2)
            .then((res) => {
              console.log("res", res);
              if (res.code == 1) {
                this.dialogExprot = false;
                const href = URL.createObjectURL(res.blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.setAttribute("href", href);
                a.download = res.fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(href);
              } else {
                this.$message.error("导出失败");
              }
            })
            .catch(() => {
              this.$message.error(res.code);
            });
          break;
        case 3:
          console.log("实物导出");
          // 查询列表
          let formObj3 = this.$refs.export_fun_sw2.export_fun2();
          let pamams3 = {
            ...formObj3,
            activityId: this.formList.activityId,
            code: this.code,
            prizeStatus: this.formList.prizeStatus || "",
          };
          console.log("参数", pamams3);
          goodsRecordExport(pamams3)
            .then((res) => {
              console.log("res", res);
              if (res.code == 1) {
                this.dialogExprot = false;
                const href = URL.createObjectURL(res.blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.setAttribute("href", href);
                a.download = res.fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(href);
              } else {
                this.$message.error("导出失败");
              }
            })
            .catch(() => {
              this.$message.error(res.code);
            });
          break;
      }
    },
    // 派样回购礼 导出
    getApi_Exprot3(tabName = 1) {
      // console.log("派样回购礼");
      switch (tabName) {
        case 1:
          console.log("活动统计");
          // 活动统计
          let params = {
            activityId: this.formList.activityId,
            code: this.code,
            endTime: this.postForm.endDate || "",
            startTime: this.postForm.startDate || "",
            pin: this.postForm.pin || "",
            current: 1,
            type: 1,
            size: 9999999,
          };
          if (
            params.startTime.indexOf("00:00:00") != -1 &&
            params.endTime.indexOf("23:59:59") != -1
          ) {
            params.startTime = this.postForm.startDate;
            params.endTime = this.postForm.endDate;
          } else {
            params.startTime = this.postForm.startDate + " 00:00:00";
            params.endTime = this.postForm.endDate + " 23:59:59";
          }
          // console.log("参数", params);
          sendSampleRecordExport(params)
            .then((res) => {
              console.log("res", res);
              if (res.code == 1) {
                this.dialogExprot = false;
                const href = URL.createObjectURL(res.blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.setAttribute("href", href);
                a.download = res.fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(href);
              } else {
                this.$message.error("导出失败");
              }
            })
            .catch(() => {
              this.$message.error(res.code);
            });
          break;
        case 2:
          // 派样下单记录
          let params2 = {
            ...this.formList,
            activityId: this.formList.activityId,
            code: this.code,
            current: 1,
            type: 0,
            size: 9999999,
          };
          // console.log("参数", params2);
          orderRecordPageExport(params2)
            .then((res) => {
              console.log("res", res);
              if (res.code == 1) {
                this.dialogExprot = false;
                const href = URL.createObjectURL(res.blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.setAttribute("href", href);
                a.download = res.fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(href);
              } else {
                this.$message.error("导出失败");
              }
            })
            .catch(() => {
              this.$message.error(res.code);
            });
          break;
        case 3:
          let params3 = {
            ...this.formList,
            activityId: this.formList.activityId,
            code: this.code,
            current: 1,
            size: 9999999,
            type: 1,
          };
          // console.log("参数", params3);
          orderRecordPageExport(params3)
            .then((res) => {
              console.log("res", res);
              if (res.code == 1) {
                this.dialogExprot = false;
                const href = URL.createObjectURL(res.blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.setAttribute("href", href);
                a.download = res.fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(href);
              } else {
                this.$message.error("导出失败");
              }
            })
            .catch(() => {
              this.$message.error(res.code);
            });
          break;
      }
    },
    // 随单发导出
    getApi_Exprot5(exportRemark = "") {
      let params = {
        activityId: this.formList.activityId,
        // code: this.code,
        endTime: this.postForm.endDate || "",
        startTime: this.postForm.startDate || "",
        pin: this.postForm.pin || "",
        current: 1,
        size: 9999999,
      };
      if (
        params.startTime.indexOf("00:00:00") != -1 &&
        params.endTime.indexOf("23:59:59") != -1
      ) {
        params.startTime = this.postForm.startDate;
        params.endTime = this.postForm.endDate;
      } else {
        params.startTime = this.postForm.startDate + " 00:00:00";
        params.endTime = this.postForm.endDate + " 23:59:59";
      }
      params.exportRemark = exportRemark
      sendSampleRecordExportOne(params)
        .then((res) => {
          console.log("res", res);
          if (res.code == 1) {
            return;
            this.dialogExprot = false;
            const href = URL.createObjectURL(res.blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.setAttribute("href", href);
            a.download = res.fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
          } else {
            this.$message.error("导出失败");
          }
        })
        .catch(() => {
          this.$message.error(res.code);
        });
    },
    // 生日有礼 导出
    getApi_Exprot4() {
      let params = {
        activityId: this.formList.activityId,
        code: this.code,
        endTime: this.postForm.endDate || "",
        startTime: this.postForm.startDate || "",
        pin: this.postForm.pin || "",
        source: 1,
      };
      if (
        params.startTime.indexOf("00:00:00") != -1 &&
        params.endTime.indexOf("23:59:59") != -1
      ) {
        params.startTime = this.postForm.startDate;
        params.endTime = this.postForm.endDate;
      } else {
        params.startTime = this.postForm.startDate + " 00:00:00";
        params.endTime = this.postForm.endDate + " 23:59:59";
      }
      pointActivityEffectDetailsExport(params)
        .then((res) => {
          console.log("res", res);
          if (res.code == 1) {
            this.dialogExprot = false;
            const href = URL.createObjectURL(res.blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.setAttribute("href", href);
            a.download = res.fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
          } else {
            this.$message.error("导出失败");
          }
        })
        .catch(() => {
          this.$message.error(res.code);
        });
    },
    // 返回value
    fitersTypeValue(val) {
      let arr = [
        "",
        "每日打卡",
        "浏览店铺",
        "浏览商品",
        "加购商品",
        "浏览会场",
        "关注店铺",
        "开卡入会",
        "好友助力",
      ];
      return arr[val];
    },
    // 抽奖机会赠送记录-大转盘
    fitersTypeValue2(val) {
      let arr = [
        { label: "每日签到", value: 1 },
        { label: "浏览店铺", value: 2 },
        { label: "浏览商品", value: 13 },
        { label: "加购商品", value: 4 },
        { label: "分享商品", value: 9 },
        { label: "分享店铺", value: 10 },
        { label: "分享活动", value: 11 },
        { label: "好友助力", value: 8 },
        { label: "浏览会场", value: 5 },
        { label: "预约商品", value: 12 },
        { label: "首次赠送", value: 14 },
        { label: "每日赠送", value: 15 },
        { label: "积分兑换", value: 16 },
        { label: "购买商品", value: 17 },
      ];
      const index = arr.findIndex((item) => item.value == val);
      if (index != -1) {
        return arr[index].label;
      } else {
        return "";
      }
    },
    // 抽奖机会赠送记录-大转盘-赠送记录
    fitersTypeValue3(row) {
      let str = "";
      let arr = [];
      if (row.orderList) {
        row.orderList.forEach((item) => {
          arr.push(item.orderId);
        });
      }
      str = arr.join(",");
      return str;
    },
    // 抽奖机会赠送记录-大转盘-赠送记录
    fitersTypeValue4(row) {
      let arr = [];
      if (row.orderList) {
        row.orderList.forEach((item) => {
          arr.push(
            `订单号：${item.orderId},订单金额：${item.price}元,订单状态：${item.orderState}`
          );
        });
      }
      return arr;
    },
    // 活动类型 三元表达式 判断显示文字
    fitersRepurchase(arr, val1, val2) {
      let isfaly = false;
      arr.forEach((item) => {
        if (this.rowData.activityType == item) {
          isfaly = true;
        }
      });
      return isfaly ? val1 : val2;
    },
    // this.rowData.activityType活动类型判断显示隐藏type === "=="则arr里面显示,type === "！="   则arr里面不显示
    fitersChooseIF(arr, type = "==") {
      if (type === "==") {
        let isfaly = false;
        arr.forEach((item) => {
          if (this.rowData.activityType == item) {
            isfaly = true;
          }
        });
        return isfaly;
      } else {
        let isfaly = true;
        arr.forEach((item) => {
          if (this.rowData.activityType == item) {
            isfaly = false;
          }
        });
        return isfaly;
      }
    },
    //下单转化数据
    getShopGiftParticipateConver() {
      let tt = "00:00:00",
        start = "",
        end = "",
        startTime = "",
        endTime = "",
        tt1 = "23:59:59";
      if (this.queryForm.evaluateTime == 0) {
        if (this.postForm.startDate == "" || this.postForm.endDate == "") {
          this.$message({
            message: "自定义时间不能为空！",
            type: "warning",
          });
          return;
        }
        start = `${this.postForm.startDate} ${tt}`;
        end = `${this.postForm.endDate} ${tt1}`;
      }
      if (this.queryForm.evaluateTime == 0) {
        startTime = start;
        endTime = end;
      } else {
        startTime = this.postForm.startDate;
        endTime = this.postForm.endDate;
      }
      getShopGiftParticipateConver({
        activityId: this.formList.activityId,
        startTime,
        endTime,
        source: this.fitersChooseIF([9, 10, 29, 30, 38]) ? 2 : 1,
      })
        .then((res) => {
          console.log(res);
          if (res.code == 1) {
            this.tatal_num = res.data;
          } else {
            this.tatal_num = {
              gmv: 0,
              newShopGmv: 0,
              newShopUsers: 0,
              ordNum: 0,
              ordRate: 0,
              users: 0,
            };
          }
        })
        .catch(() => {});
    },
    //返回列表
    toSetting() {
      this.$emit("returnStep");
    },
    //页头点击
    async handleClick(tab, event) {
      this.formList = {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
      };
      // this.totalMail = 0
      this.multipleSelection = [];
      this.tabName = tab.name;
      this.actTab = tab;
      // 活动统计
      if (tab.name === "first") {
        await this.queryTotal();
        await this.initChart();
        await this.initChart1();

        this.getShopGiftParticipateConver();
      }
      // 签到纪录
      if (tab.name === "second") {
        this.checkRecord();
      }
      // 中奖记录
      if (tab.name === "third") {
        this.formList.unlockOrderId = "";
        this.formList.status = "";
        this.$refs.awardRef.resetForm();
        // this.winningRecord();
      }
      //邀请统计
      if (tab.name === "sevent") {
        this.statistics();
      }
      // 被邀请人明细
      if (tab.name === "inviteeDetails") {
        this.toGetInviteDetail();
      }
      // 实物奖品
      if (tab.name === "four") {
        console.log("实物奖品");
        this.formList.status = "";
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.inKingRecord();
      }
      // 用户资料明细
      if (tab.name === "five") {
        let res = await getActivityRuleFields(this.formList.activityId);
        console.log(res);
        this.RuleFieldsList = res.data.infoNames;
        if (res.data.showAllStaticField) {
          this.RuleFieldsList = [
            "姓名",
            "手机号码",
            "生日",
            "微信",
            "QQ",
            "邮箱",
            "性别",
            "职业",
            "地区",
            "详细地址",
          ];
        }
        if (res.data.showExtendInfo) {
          this.RuleFieldsList.push("扩展信息");
        }

        this.improveRecord();
      }
      //发放记录
      if (tab.name === "six") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.distributionRecord();
      }
      //拼券明细
      if (tab.name === "seven") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.commentDraw();
      }
      //拼券明细
      if (tab.name === "eight") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.CoupondDtails();
      }
      //优惠券统计
      if (tab.name === "nine") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.CouponStatistics();
      }
      //团队详情
      if (tab.name === "ten") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.TeamDetails();
      }
      // 参与记录
      if (tab.name === "eleven") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.getParticipation();
      }
      // 参与赠送
      if (tab.name === "twelve") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.getGameTaskRecord();
      }
      //兑换记录
      if (tab.name === "thirteen" || tab.name === "fourteen") {
        this.formList.startTime = this.getDateStr(-30) + " 00:00:00";
        this.formList.endTime = this.getDateStr(0) + " 23:59:59";
        this.getList();
      }
      // 加购记录
      if (tab.name == "thirtyFour") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.addCartpage();
      }
      // 锁权记录
      if (tab.name == "eighteen") {
        // this.formList.createTimeStart = ""
        // this.formList.createTimeEnd = ""
        this.$refs.export_fun18.resetForm();
        // this.lockRightRecord()
      }
      // 积分锁权 中奖记录
      if (tab.name === "sixteen") {
        this.$refs.export_fun16.resetForm();
        // this.winningRecord();
      }
      // 积分锁权 收货信息 派样回购
      if (tab.name === "seventeen") {
        this.$refs.export_fun17.resetForm();
        // this.takeGoodsRecord();
      }
      if (tab.name === "twenty-two") {
        this.formList.memberNick = "";
        this.formList.checkStartTime = "";
        this.formList.checkEndTime = "";
        this.formList.unlockOrderId = "";
        this.$refs.export_xdyl.resetForm();
        // this.getUnlockRecord();
      }
      // 打榜有礼领奖记录
      if (tab.name === "twenty-one") {
        console.log("formList", this.formList);
        console.log("打榜有礼领奖记录");
        this.formList.status = "";
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.formList.sendTimeStart = "";
        this.formList.sendTimeEnd = "";
        this.formList.deliveryTimeStart = "";
        this.formList.deliveryTimeEnd = "";
        this.getWinRecord();
      }
      // 打榜有礼实物奖品名单
      if (tab.name === "twenty") {
        console.log("formList", this.formList);
        console.log("打榜有礼实物奖品名单");
        this.formList.status = "";
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.formList.sendTimeStart = "";
        this.formList.sendTimeEnd = "";
        this.formList.deliveryTimeStart = "";
        this.formList.deliveryTimeEnd = "";
        if (this.rowData.activityType == 39) {
          this.formList.status = "";
        } else {
          this.formList.prizeStatus = "";
        }
        this.getGoodsRecord();
      }
      // 派样下单记录
      if (tab.name === "sendReBuyPay") {
        console.log("formList", this.formList);
        this.formList.pin = "";
        this.formList.skuId = "";
        this.formList.skuName = "";
        this.formList.orderId = "";
        this.formList.isCommitAddress = null;
        this.formList.orderTimeStart = "";
        this.formList.orderTimeEnd = "";
        this.formList.receiveTimeStart = "";
        this.formList.receiveTimeEnd = "";
        this.formList.type = 0;
        this.$refs.inputSendBuyPayRef.resetForm();
        // this.getSendBuyPayData();
      }
      // 回购下单记录
      if (tab.name === "sendReBuyRePay") {
        console.log("formList", this.formList);
        this.formList.pin = "";
        this.formList.skuId = "";
        this.formList.skuName = "";
        this.formList.orderId = "";
        this.formList.orderPaymentStart = "";
        this.formList.orderPaymentEnd = "";
        this.formList.isWin = null;
        this.formList.isCommitAddress = null;
        this.formList.orderTimeStart = "";
        this.formList.orderTimeEnd = "";
        this.formList.receiveTimeStart = "";
        this.formList.receiveTimeEnd = "";
        this.formList.type = 1;
        this.$refs.inputSendBuyRePayRef.resetForm();
        // this.getSendBuyRePayData();
      }
      if (tab.name === "sendReBuyPayRandom") {
        console.log("formList", this.formList);
        this.formList.pin = "";
        this.formList.skuId = "";
        this.formList.skuName = "";
        this.formList.orderId = "";
        this.formList.paymentConfirmTimeStart = "";
        this.formList.paymentConfirmTimeEnd = "";
        this.formList.orderTimeEnd = "";
        this.formList.orderStateRemark = "";
        this.formList.orderEndTimeStart = "";
        this.formList.orderEndTimeEnd = "";
        this.formList.orderType = 0;
        this.$refs.sendReBuyPayRandomRef.resetForm();
        // this.getSendBuyPayData();
      }
      if (tab.name === "inputTokenRePay") {
        this.formList.pin = "";
        this.formList.sendStatus = "";
        this.formList.sendTimeStart = "";
        this.formList.sendTimeEnd = "";
        this.formList.tokenId = "";
        this.$refs.inputTokenRePay.resetForm();
      }
      if (tab.name === "inputTokenRePayOne") {
        this.formList.pin = "";
        this.formList.isHaveGive = "";
        this.$refs.inputTokenRePayOne.resetForm();
      }
      if (tab.name === "sendReBuyRePayRandom") {
        console.log("formList", this.formList);
        this.formList.pin = "";
        this.formList.skuId = "";
        this.formList.skuName = "";
        this.formList.orderId = "";
        this.formList.paymentConfirmTimeStart = "";
        this.formList.paymentConfirmTimeEnd = "";
        this.formList.orderTimeEnd = "";
        this.formList.orderStateRemark = "";
        this.formList.orderEndTimeStart = "";
        this.formList.orderEndTimeEnd = "";
        this.formList.orderType = 1;
        this.$refs.sendReBuyRePayRandomRef.resetForm();
        // this.getSendBuyPayData();
      }
      // 领取记录
      if (tab.name == "getRecord") {
        this.formListRecord = {
          size: 10,
          current: 1,
          activityId: this.rowData.id,
        };
        this.getRecord();
      }
    },
    timeChange(type) {
      let self = this;
      // let hh = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours();
      // let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
      // let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
      // let tt = "00:00:00";
      // const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      // this.mytime = date;
      if (type == null) {
        let time = this.$getActDate(7, this.rowData.startTime);
        this.postForm.startDate = time[0].substring(0, 10) + " 00:00:00";
        this.postForm.endDate = time[1].substring(0, 10) + " 23:59:59";
        // this.postForm.startDate = `${this.mytime[0]} ${tt}`;
        // this.postForm.endDate = `${this.mytime[1]} ${tt}`;
      } else if (type == 7) {
        let time = this.$getActDate(7, this.rowData.startTime);
        this.postForm.startDate = time[0].substring(0, 10) + " 00:00:00";
        this.postForm.endDate = time[1].substring(0, 10) + " 23:59:59";
        // this.postForm.startDate = `${this.mytime[0]} ${tt}`;
        // this.postForm.endDate = `${this.mytime[1]} ${tt}`;
      } else if (type == 15) {
        let time = this.$getActDate(15, this.rowData.startTime);
        this.postForm.startDate = time[0].substring(0, 10) + " 00:00:00";
        this.postForm.endDate = time[1].substring(0, 10) + " 23:59:59";
        // this.postForm.startDate = this.$getActDate(15, this.rowData.startTime)[0];
        // this.postForm.endDate = this.$getActDate(15, this.rowData.startTime)[1];
      } else if (type == 30) {
        let time = this.$getActDate(30, this.rowData.startTime);
        this.postForm.startDate = time[0].substring(0, 10) + " 00:00:00";
        this.postForm.endDate = time[1].substring(0, 10) + " 23:59:59";
        // this.postForm.startDate = this.$getActDate(30, this.rowData.startTime)[0];
        // this.postForm.endDate = this.$getActDate(30, this.rowData.startTime)[1];
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
    //时间限制
    clearTimeSendTime() {
      this.postForm.startDate = "";
      this.postForm.endDate = "";
    },
    // 查询按钮
    querySeach() {
      this.formList.current = 1;
      this.formList.size = 10;
      this.queryTotal();
      this.getShopGiftParticipateConver();
    },
    //查询数据总和
    async queryTotal() {
      // this.formList.current = 1;
      let tt = "00:00:00",
        start = "",
        end = "",
        startTime = "",
        endTime = "",
        tt1 = "23:59:59";
      if (this.queryForm.evaluateTime == 0) {
        if (this.postForm.startDate == "" || this.postForm.endDate == "") {
          this.$message({
            message: "自定义时间不能为空！",
            type: "warning",
          });
          return;
        }
        start = `${this.postForm.startDate} ${tt}`;
        end = `${this.postForm.endDate} ${tt1}`;
      }
      if (this.queryForm.evaluateTime == 0) {
        startTime = start;
        endTime = end;
      } else {
        startTime = this.postForm.startDate;
        endTime = this.postForm.endDate;
      }
      // 小部件
      if (this.fitersChooseIF([25, 26, 32, 33,56,57])) {
        // 获取数据汇总
        getSmartDataSum({
          activityId: this.formList.activityId,
          startTime,
          endTime,
        }).then((res) => {
          this.loading = false;
          // 数据总览数据
          this.tableTotal = res.data;
          console.log("数据总览数据", res.data);
        });
        // 获取数据明细
        getSmartDataDetail({
          activityId: this.formList.activityId,
          startTime,
          endTime,
        }).then((res) => {
          // 折线图数据
          let dataList = res.data;
          console.log("折线图数据", res.data);
          if (dataList.length == 1 && dataList.length == 0) {
            this.$message.error("折线图时间过短");
          } else {
            dataList.forEach((item) => {
              item.orderRate = item.orderRate / 100;
              item.cartRate = item.cartRate / 100;
              item.clickRate = item.clickRate / 100;
              item.payOrderRate = item.payOrderRate / 100;
              item.visitUsrPayOrderRate = item.visitUsrPayOrderRate / 100;
            });
            this.chartEffectDetail = dataList;
            this.$nextTick(() => {
              this.initChart();
              window.addEventListener("resize", () => {
                this.myCharts.resize();
              });
            });
          }
        });
      } else if (this.fitersChooseIF([36])) {
        // 打榜有礼数据总览
        getDataOverview({
          activityId: this.formList.activityId,
          startTime,
          endTime,
        }).then((res) => {
          let rdata = res.data;
          this.loading = false;
          this.tableTotal = rdata;
        });
        getDetailPage({
          activityId: this.formList.activityId,
          startTime,
          endTime,
          size: this.formList.size,
          current: this.formList.current,
        }).then((res) => {
          let rdata = res.data;
          if (rdata.records.length == 1 && rdata.records.length == 0) {
            this.$message.error("折线图时间过短");
          } else {
            this.chartEffectDetail = rdata.records;
            console.log("chartEffectDetail", this.chartEffectDetail);
            this.$nextTick(() => {
              this.initChart();
              window.addEventListener("resize", () => {
                this.myCharts.resize();
              });
            });
          }
          this.loading = false;
          this.activityTable = rdata.records;
          // 列表数据
          this.totalNum = Number(res.data.total);
        });
      } else if (this.fitersChooseIF([35])) {
        getSumLockEffectJi({
          activityId: this.formList.activityId,
          startTime,
          endTime,
          channelCode: this.postForm.channelCode,
        }).then((res) => {
          this.loading = false;
          this.tableTotal = res.data;
        });

        //折线图数据查询
        const { data: data } = await getDetailLockEffectJi({
          activityId: this.formList.activityId,
          startTime,
          endTime,
          current: 1,
          size: 9999999,
          channelCode: this.postForm.channelCode,
        });
        if (data.records.length == 1 && data.records.length == 0) {
          this.$message.error("折线图时间过短");
        } else {
          this.chartEffectDetail = data.records.reverse();
          this.$nextTick(() => {
            this.initChart();
            window.addEventListener("resize", () => {
              this.myCharts.resize();
            });
          });
        }
      } else if (this.fitersChooseIF([43])) {
        this.loading = true;
        // 数据概况
        getSumEffectOne({
          activityId: this.formList.activityId,
          startTime,
          endTime,
          type: 0,
        })
          .then((res) => {
            let rdata = res.data;
            console.log(rdata, "2131231232133213");
            rdata.enterReBuyRate = rdata.enterReBuyRate + "%";
            rdata.orderReBuyRate = rdata.orderReBuyRate + "%";
            this.loading = false;
            this.tableTotal = rdata;
          })
          .catch((err) => {
            this.$message.error(err);
          });
        setTimeout(() => {
          getSumEffectOne({
            activityId: this.formList.activityId,
            startTime,
            endTime,
            type: 1,
          })
            .then((res) => {
              let rdata = res.data;
              rdata.enterReBuyRate = rdata.enterReBuyRate + "%";
              rdata.orderReBuyRate = rdata.orderReBuyRate + "%";
              this.loading = false;
              this.tableTotal1 = rdata;
            })
            .catch((err) => {
              this.$message.error(err);
            });
        }, 500);
        // 折线图
        getDetailEffectOne({
          activityId: this.formList.activityId,
          startTime,
          endTime,
          size: 9999,
          current: this.formList.current,
          type: 0,
        })
          .then((res) => {
            let rdata = res.data;
            if (rdata.records.length == 1 && rdata.records.length == 0) {
              this.$message.error("折线图时间过短");
            } else {
              this.chartEffectDetail = rdata.records;
              this.$nextTick(() => {
                this.initChart();
                window.addEventListener("resize", () => {
                  this.myCharts.resize();
                });
              });
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
        this.chartEffectDetail1 = [];
        getDetailEffectOne({
          activityId: this.formList.activityId,
          startTime,
          endTime,
          size: 9999,
          current: this.formList.current,
          type: 1,
        })
          .then((res) => {
            let rdata = res.data;
            if (rdata.records.length == 1 && rdata.records.length == 0) {
              this.$message.error("折线图时间过短");
            } else {
              this.chartEffectDetail1 = rdata.records;
              this.$nextTick(() => {
                this.initChart1();
                window.addEventListener("resize", () => {
                  this.myCharts1.resize();
                });
              });
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });

        // 列表数据
        this.getIncludeTotalDetail()
      } else if (this.fitersChooseIF([37])) {
        this.loading = true;
        // 数据概况
        getSumEffect({
          activityId: this.formList.activityId,
          startTime,
          endTime,
        })
          .then((res) => {
            let rdata = res.data;
            this.loading = false;
            this.tableTotal = rdata;
          })
          .catch((err) => {
            this.$message.error(err);
          });
        // 折线图
        getDetailEffect({
          activityId: this.formList.activityId,
          startTime,
          endTime,
          size: this.formList.size,
          current: this.formList.current,
        })
          .then((res) => {
            let rdata = res.data;
            if (rdata.records.length == 1 && rdata.records.length == 0) {
              this.$message.error("折线图时间过短");
            } else {
              this.chartEffectDetail = rdata.records;
              this.$nextTick(() => {
                this.initChart();
                window.addEventListener("resize", () => {
                  this.myCharts.resize();
                });
              });
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
        // 列表数据
        this.activityTable = [];
        getDetailIncludeTotal({
          activityId: this.formList.activityId,
          startTime,
          endTime,
          size: this.formList.size,
          current: this.formList.current,
        })
          .then((res) => {
            if (res.code == 1) {
              let rdata = res.data;
              this.loading = false;
              rdata.records.forEach((item) => {
                item.enterReBuyRate = item.enterReBuyRate + "%";
                item.orderReBuyRate = item.orderReBuyRate + "%";
              });
              console.log("activityTable", this.activityTable);
              this.activityTable = rdata.records;
              // 列表数据
              this.totalNum = Number(res.data.total);
            } else {
              this.$message.error(res.message);
              this.loading = false;
            }
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      } else {
        getCouponData({
          activityId: this.formList.activityId,
          startTime,
          endTime,
          source: this.fitersChooseIF([9, 10, 29, 30, 38]) ? 2 : 1,
        }).then((res) => {
          this.loading = false;
          this.tableTotal = res.data;
        });

        //折线图数据查询
        const { data: dataList } = await checkRecord({
          activityId: this.formList.activityId,
          startTime,
          endTime,
          source: this.fitersChooseIF([9, 10, 29, 30, 38]) ? 2 : 1,
        });
        if (dataList.length == 1 && dataList.length == 0) {
          this.$message.error("折线图时间过短");
        } else {
          this.chartEffectDetail = dataList;
          this.$nextTick(() => {
            this.initChart();
            window.addEventListener("resize", () => {
              this.myCharts.resize();
            });
          });
        }
      }
      if (this.fitersChooseIF([35])) {
        getDetailLockEffectJi({
          activityId: this.formList.activityId,
          size: this.formList.size,
          current: this.formList.current,
          startTime,
          endTime,
          channelCode: this.postForm.channelCode,
        })
          .then((res) => {
            this.loading = false;
            this.activityTable = res.data.records;
            this.totalNum = Number(res.data.total);
            // console.log(this.postForm.endDate);
          })
          .catch((res) => {
            // this.$message.error("输入时间错误1");
          });
      } else if (this.fitersChooseIF([36, 37, 43], "!=")) {
        //列表数据查询
        getCouponTable({
          activityId: this.formList.activityId,
          size: this.formList.size,
          current: this.formList.current,
          startTime,
          endTime,
          source: this.fitersChooseIF([9, 10, 29, 30, 38]) ? 2 : 1,
        })
          .then((res) => {
            this.loading = false;
            this.activityTable = res.data.records;
            this.totalNum = Number(res.data.total);
            // console.log(this.postForm.endDate);
          })
          .catch((res) => {
            // this.$message.error("输入时间错误1");
          });
      }
    },
    // 随单发统计详情
    getIncludeTotalDetail() {
      let tt = "00:00:00",
      start = "",
      end = "",
      startTime = "",
      endTime = "",
      tt1 = "23:59:59";
    if (this.queryForm.evaluateTime == 0) {
      if (this.postForm.startDate == "" || this.postForm.endDate == "") {
        this.$message({
          message: "自定义时间不能为空！",
          type: "warning",
        });
        return;
      }
      start = `${this.postForm.startDate} ${tt}`;
      end = `${this.postForm.endDate} ${tt1}`;
    }
    if (this.queryForm.evaluateTime == 0) {
      startTime = start;
      endTime = end;
    } else {
      startTime = this.postForm.startDate;
      endTime = this.postForm.endDate;
    }
      this.activityTable = [];
      getDetailIncludeTotalOne({
        activityId: this.formList.activityId,
        startTime,
        endTime,
        size: this.formList.size,
        current: this.formList.current,
      })
        .then((res) => {
          if (res.code == 1) {
            let rdata = res.data;
            this.loading = false;
            rdata.records.forEach((item) => {
              item.enterReBuyRate = item.enterReBuyRate + "%";
              item.orderReBuyRate = item.orderReBuyRate + "%";
            });
            this.activityTable = [];
            console.log("activityTable", this.activityTable);
            this.activityTable = rdata.records;
            // 列表数据
            this.totalNum = Number(res.data.total);
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    //折线图
    initChart() {
      if (this.rowData.activityType != 15) {
        this.myCharts = echarts.init(this.$refs.payRemindChart);
        this.setOptions();
      }
    },
    initChart1() {
      if (this.rowData.activityType != 15) {
        this.myCharts1 = echarts.init(this.$refs.payRemindChart1);
        this.setOptions1();
      }
    },
    //折线图事件
    setOptions() {
      if (this.fitersChooseIF([35])) {
        var seriesList = this.dataSummary1.map((item) => {
          return {
            name: item.name,
            type: "line",
            smooth: true,
            color: item.color,
            data: this.chartEffectDetail.map((i) => i[item.value]),
          };
        });
      } else if (this.fitersChooseIF([36, 37])) {
        var seriesList = this.dataSummary.map((item) => {
          return {
            name: item.name,
            type: "line",
            smooth: true,
            color: item.color,
            data: this.chartEffectDetail.map((i) => {
              return i[item.value] ? Number(i[item.value]) : 0;
            }),
          };
        });
      } else {
        var seriesList = this.dataSummary.map((item) => {
          return {
            name: item.name,
            type: "line",
            smooth: true,
            color: item.color,
            // 无数据显示0处理
            data: this.chartEffectDetail.map((i) =>
              i[item.value] ? i[item.value] : 0
            ),
          };
        });
      }
      let option = {
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            return this.echartIcon(params);
          },
        },
        legend: {
          // data: ["活动PV", "活动UV", "参与人数", "参与次数", "人均参与次数"],
          data: this.fitersChooseIF([35])
            ? this.dataSummary1.map((item) => item.name)
            : this.dataSummary.map((item) => item.name),
          bottom: -5,
          left: "center",
          // x: "center",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: this.fitersChooseIF([37, 43]) ? "16%" : "11%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.fitersChooseIF([35, 36, 37, 43])
            ? this.chartEffectDetail.map((item) => item.statsDate)
            : this.chartEffectDetail.map((item) => item.dateTime),
        },
        yAxis: {
          type: "value",
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: seriesList,
      };

      this.myCharts.setOption(option);
    },
    //折线图事件
    setOptions1() {
      if (this.fitersChooseIF([35])) {
        var seriesList = this.dataSummary1.map((item) => {
          return {
            name: item.name,
            type: "line",
            smooth: true,
            color: item.color,
            data: this.chartEffectDetail.map((i) => i[item.value]),
          };
        });
      } else if (this.fitersChooseIF([36, 37])) {
        var seriesList = this.dataSummaryOne.map((item) => {
          return {
            name: item.name,
            type: "line",
            smooth: true,
            color: item.color,
            data: this.chartEffectDetail1.map((i) => {
              return i[item.value] ? Number(i[item.value]) : 0;
            }),
          };
        });
      } else {
        var seriesList = this.dataSummaryOne.map((item) => {
          return {
            name: item.name,
            type: "line",
            smooth: true,
            color: item.color,
            // 无数据显示0处理
            data: this.chartEffectDetail1.map((i) =>
              i[item.value] ? i[item.value] : 0
            ),
          };
        });
      }
      let option = {
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            return this.echartIcon(params);
          },
        },
        legend: {
          // data: ["活动PV", "活动UV", "参与人数", "参与次数", "人均参与次数"],
          data: this.fitersChooseIF([35])
            ? this.dataSummary1.map((item) => item.name)
            : this.dataSummaryOne.map((item) => item.name),
          bottom: -5,
          left: "center",
          // x: "center",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: this.fitersChooseIF([37, 43]) ? "16%" : "11%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.fitersChooseIF([35, 36, 37, 43])
            ? this.chartEffectDetail1.map((item) => item.statsDate)
            : this.chartEffectDetail1.map((item) => item.dateTime),
        },
        yAxis: {
          type: "value",
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: seriesList,
      };

      this.myCharts1.setOption(option);
    },
    //重置
    queryOne() {
      this.formList.current = 1;
      this.formList.size = 10;
      this.queryForm.evaluateTime = "7";
      this.queryForm.channelCode = "";
      this.timeChange(7);
      this.queryTotal();
    },
    // 参与记录
    getParticipation() {
      this.loading = true;
      participation(this.formList)
        .then((res) => {
          this.loading = false;
          this.ParticipatTable = res.data.records;
          this.totalParticipat = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //参与赠送
    getGameTaskRecord() {
      this.loading = true;
      gameTaskRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.GiftrecordList = res.data.records;
          this.totalGiftrecord = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 抽奖机会赠送 查看详情
    commentDetails(item) {
      this.commentItem = item;
      this.commentDioag = true;
      console.log(this.commentItem);
    },
    dialogClose() {
      this.commentDioag = false;
    },
    // 团队详情 查看详情
    async viewDetails(item) {
      if (this.fitersChooseIF([31])) {
        const { data: res } = await groupMember(item.id);
        this.CouponMember = res.map((item, i) => {
          return {
            ...item,
            // group: i == 0 ? "团长" : "团员",
          };
        });
      } else {
        const { data: res } = await CouponDetailmember(item.id);
        this.CouponMember = res.map((item, i) => {
          return {
            ...item,
            group: i == 0 ? "团长" : "团员",
          };
        });
      }
      this.dialogGroup = true;
    },
    //签到记录
    checkRecord() {
      this.loading = true;
      checkList(this.formList)
        .then((res) => {
          this.loading = false;
          this.signInTable = res.data.records;
          this.totalSignIn = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 加购记录
    addCartpage() {
      this.loading = true;
      addCartpage(this.formList)
        .then((res) => {
          this.loading = false;
          this.addCartTable = res.data.records;
          this.totalAddCart = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 锁权记录
    lockRightRecord() {
      this.loading = true;
      lockRightRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.lockRightTable = res.data.records;
          this.totalLockRight = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 收货信息
    takeGoodsRecord() {
      this.loading = true;
      let params = {
        ...this.formList,
        isReceiveInfo: true,
      };
      if (this.fitersChooseIF([37])) {
        params.subType = "37";
      }
      //isReceiveInfo 是否为收货信息 true收货信息 空或不传为 积分锁权-中奖记录
      lockWinRecord(params)
        .then((res) => {
          this.loading = false;
          this.takeGoodsTable = res.data.records;
          this.totalTakeGoods = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //中奖记录
    winningRecord() {
      this.loading = true;
      // 只有邀请类的调awardRecNew接口
      if (this.rowData.activityType == 6) {
        awardRecNew(this.formList)
          .then((res) => {
            this.loading = false;
            this.awardTable = res.data.records;
            this.totalAward = Number(res.data.total);
          })
          .catch((res) => {});
      } else if (this.rowData.activityType == 5) {
        //Note---邀请开卡有礼中奖纪录接口修改
        awardRecNewOne(this.formList)
          .then((res) => {
            this.loading = false;
            this.awardTable = res.data.records;
            this.totalAward = Number(res.data.total);
          })
          .catch((res) => {});
      } else if (this.rowData.activityType == 33) {
        this.formList.subType = 33;
        getGoodRecords(this.formList).then((res) => {
          this.loading = false;
          this.awardTable = res.data.records;
          this.totalAward = Number(res.data.total);
        });
      } else if (this.rowData.activityType == 35) {
        // 积分锁权 中奖记录
        lockWinRecord(this.formList).then((res) => {
          this.loading = false;
          this.awardTable = res.data.records;
          this.totalAward = Number(res.data.total);
        });
      } else if (this.rowData.activityType == 37) {
        let params = {
          subType: "37",
          ...this.formList,
        };
        // 派样回购礼
        lockWinRecord(params).then((res) => {
          this.loading = false;
          this.awardTable = res.data.records;
          this.totalAward = Number(res.data.total);
        });
      } else {
        awardRecord(this.formList)
          .then((res) => {
            this.loading = false;
            this.awardTable = res.data.records;
            this.totalAward = Number(res.data.total);
          })
          .catch((res) => {});
      }
    },
    //发放记录 为中奖记录的接口awardRecord
    distributionRecord() {
      this.loading = true;
      // awardRecNew(this.formList)
      awardRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.distributionTable = res.data.records;
          this.totalDistribution = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 创建a标签下载
    createAndDownload(res) {
      const href = URL.createObjectURL(res.blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.setAttribute("href", href);
      a.download = res.fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(href);
    },
    // 获取当前信息，判断导出身份验证开关状态
    async getDownloadVerify() {
      try {
        const res = await querySellerSetting();
        if (res.code === 1) {
          return res.data.isOpenDownloadRemind === 0;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    submitExport(obj) {
      this.exportTheData(obj.code);
    },
    submitExport2(obj) {
      this.exportTheData2(obj.code);
    },
    // 导出
    async exportTheData2(code = "") {
      let isNullCode = /^\s*$/.test(code);
      const isShowVerify = await this.getDownloadVerify();
      //验证码为空且验证为开启
      if (isNullCode && isShowVerify) {
        this.isShowVerify = true;
        return;
      }
      let isStringCode = typeof code == "string";
      if (!isStringCode && isShowVerify) {
        this.isShowVerify = true;
        return;
      }
      var formDate = JSON.parse(sessionStorage.getItem("exportForm"));
      if (this.rowData.activityType == 16) {
        //更改为post（blob）请求
        let param = this.formList.activityId;
        exportCheckOrderDetail({
          activityId: encodeURI(param),
          current: formDate.current,
          size: formDate.size,
          memberNick: formDate.memberNick,
          checkStartTime: formDate.checkStartTime || "",
          checkEndTime: formDate.checkEndTime || "",
          unlockOrderId: formDate.unlockOrderId,
          isUnLockOrder: true,
          pin: formDate.pin || "",
          code: typeof code === "string" ? code : undefined,
        }).then((res) => {
          if (res.code == 1) {
            this.createAndDownload(res);
          } else {
            this.$message.warning(res.message);
          }
        });
        // let elem = document.createElement("a");
        // elem.style.display = "none";
        // let url = `/jd-hd-web/PointActivityEffectDetails/exportCheckOrderDetail?activityId=${encodeURI(param)}&current=${formDate.current}&size=${formDate.size}&memberNick=${formDate.memberNick}&checkStartTime=${formDate.checkStartTime?formDate.checkStartTime:''}&checkEndTime=${formDate.checkEndTime?formDate.checkEndTime:''}&unlockOrderId=${formDate.unlockOrderId}&isUnLockOrder=${true}&pin=${formDate.pin ? formDate.pin : '' }`;
        // elem.href = url;
        // document.body.appendChild(elem);
        // elem.click();
        // document.body.removeChild(elem);
      }
    },
    //导出
    async exportTheData(code = "") {
      console.log("activityType", this.rowData.activityType);
      let isNullCode = /^\s*$/.test(code);
      const isShowVerify = await this.getDownloadVerify();
      //验证码为空且验证为开启
      if (isNullCode && isShowVerify) {
        this.isShowVerify = true;
        return;
      }
      let isStringCode = typeof code == "string";
      if (!isStringCode && isShowVerify) {
        this.isShowVerify = true;
        return;
      }
      var formDate = JSON.parse(sessionStorage.getItem("exportForm"));
      if (this.rowData.activityType == 6) {
        //更改为post（blob）请求
        let param = this.formList.activityId;
        exportRecNew({
          activityId: encodeURI(param),
          current: formDate.current,
          size: formDate.size,
          startTime: formDate.startTime || "",
          endTime: formDate.endTime || "",
          prizeType: formDate.prizeType || "",
          status: formDate.status || "",
          memberNick: formDate.memberNick || "",
          orderState: formDate.orderState || "",
          unlockOrderId: formDate.unlockOrderId || "",
          pin: formDate.pin || "",
          code: typeof code === "string" ? code : undefined,
        }).then((res) => {
          if (res.code == 1) {
            this.createAndDownload(res);
          } else {
            this.$message.warning(res.message);
          }
        });
        // let elem = document.createElement("a");
        // elem.style.display = "none";
        // let url = `/jd-hd-web/PointActivityEffectDetails/exportPointInviteActivityPrize?activityId=${encodeURI(param)}&current=${formDate.current}&size=${formDate.size}&endTime=${formDate.endTime?formDate.endTime:''}&startTime=${formDate.startTime?formDate.startTime:''}&prizeType=${formDate.prizeType?formDate.prizeType:''}&status=${formDate.status?formDate.status:''}&memberNick=${formDate.memberNick?formDate.memberNick:''}&orderState=${formDate.orderState?formDate.orderState:''}&unlockOrderId=${formDate.unlockOrderId?formDate.unlockOrderId:""}&pin=${formDate.pin?formDate.pin:""}`;
        // elem.href = url;
        // document.body.appendChild(elem);
        // elem.click();
        // document.body.removeChild(elem);
        // exportRecNew({activityId:param}).then((res) => {});
      } else if (this.rowData.activityType == 5) {
        //更改为post（blob）请求
        let param = this.formList.activityId;
        exportPointInviteCardActivityPrize({
          activityId: encodeURI(param),
          current: formDate.current,
          size: formDate.size,
          startTime: formDate.startTime || "",
          endTime: formDate.endTime || "",
          prizeType: formDate.prizeType || "",
          status: formDate.status || "",
          memberNick: formDate.memberNick || "",
          orderState: formDate.orderState || "",
          unlockOrderId: formDate.unlockOrderId || "",
          pin: formDate.pin || "",
          code: typeof code === "string" ? code : undefined,
        }).then((res) => {
          if (res.code == 1) {
            this.createAndDownload(res);
          } else {
            this.$message.warning(res.message);
          }
        });
        // let elem = document.createElement("a");
        // elem.style.display = "none";
        // let url = `/jd-hd-web/PointActivityEffectDetails/exportPointInviteCardActivityPrize?activityId=${encodeURI(param)}&current=${formDate.current}&size=${formDate.size}&endTime=${formDate.endTime?formDate.endTime:''}&startTime=${formDate.startTime?formDate.startTime:''}&prizeType=${formDate.prizeType?formDate.prizeType:''}&status=${formDate.status?formDate.status:''}&memberNick=${formDate.memberNick?formDate.memberNick:''}&orderState=${formDate.orderState?formDate.orderState:''}&unlockOrderId=${formDate.unlockOrderId?formDate.unlockOrderId:""}&pin=${formDate.pin?formDate.pin:""}`;
        // elem.href = url;
        // document.body.appendChild(elem);
        // elem.click();
        // document.body.removeChild(elem);
      } else if (
        this.rowData.activityType == 16 ||
        this.rowData.activityType == 17 ||
        this.rowData.activityType == 18 ||
        this.rowData.activityType == 19
      ) {
        //更改为post（blob）请求
        let param = this.formList.activityId;
        exportPointActivityPrizeDetailForPurchase({
          activityId: encodeURI(param),
          current: formDate.current,
          size: formDate.size,
          startTime: formDate.startTime || "",
          endTime: formDate.endTime || "",
          prizeType: formDate.prizeType || "",
          status: formDate.status || "",
          memberNick: formDate.memberNick || "",
          orderState: formDate.orderState || "",
          unlockOrderId: formDate.unlockOrderId || "",
          pin: formDate.pin || "",
          code: typeof code === "string" ? code : undefined,
        }).then((res) => {
          if (res.code == 1) {
            this.createAndDownload(res);
          } else {
            this.$message.warning(res.message);
          }
        });
        // let elem = document.createElement("a");
        // elem.style.display = "none";
        // let url = `/jd-hd-web/PointActivityEffectDetails/exportPointActivityPrizeDetailForPurchase?activityId=${encodeURI(param)}&current=${formDate.current}&size=${formDate.size}&endTime=${formDate.endTime?formDate.endTime:''}&startTime=${formDate.startTime?formDate.startTime:''}&prizeType=${formDate.prizeType?formDate.prizeType:''}&status=${formDate.status?formDate.status:''}&memberNick=${formDate.memberNick?formDate.memberNick:''}&orderState=${formDate.orderState?formDate.orderState:''}&unlockOrderId=${formDate.unlockOrderId?formDate.unlockOrderId:""}&pin=${formDate.pin?formDate.pin:""}`;
        // if(this.rowData.activityType == 19){
        //   url += `&isWhite=${formDate.isWhite}`
        // }
        // elem.href = url;
        // document.body.appendChild(elem);
        // elem.click();
        // document.body.removeChild(elem);
      } else if (this.rowData.activityType == 33) {
        let param = this.formList.activityId;
        let elem = document.createElement("a");
        elem.style.display = "none";
        let url = `/jd-hd-web/PointActivityEffectDetails/exportGoodRecords?activityId=${encodeURI(
          param
        )}&current=${formDate.current}&size=${formDate.size}&endTime=${
          formDate.endTime ? formDate.endTime : ""
        }&startTime=${formDate.startTime ? formDate.startTime : ""}&prizeType=${
          formDate.prizeType ? formDate.prizeType : ""
        }&status=${formDate.status ? formDate.status : ""}&memberNick=${
          formDate.memberNick ? formDate.memberNick : ""
        }&orderState=${
          formDate.orderState ? formDate.orderState : ""
        }&unlockOrderId=${
          formDate.unlockOrderId ? formDate.unlockOrderId : ""
        }&pin=${formDate.pin ? formDate.pin : ""}`;
        if (!code) {
          url = url + `&code=${code}`;
        }
        elem.href = url;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      } else if (this.rowData.activityType == 39) {
        //更改为post（blob）请求
        let param = this.rowData.id;
        exportPointActivityPrizeDetail({
          activityId: encodeURI(param),
          current: this.formListRecord.current,
          size: this.formListRecord.size,
          startTime: this.formListRecord.startTime || "",
          endTime: this.formListRecord.endTime || "",
          prizeType: this.formListRecord.prizeType || "",
          status: this.formListRecord.status || "",
          memberNick: this.formListRecord.memberNick || "",
          pin: this.formListRecord.pin || "",
          code: typeof code === "string" ? code : undefined,
        }).then((res) => {
          if (res.code == 1) {
            this.createAndDownload(res);
          } else {
            this.$message.warning(res.message);
          }
        });
        // let elem = document.createElement("a");
        // elem.style.display = "none";
        // let url = `/jd-hd-web/PointActivityEffectDetails/exportPointActivityPrizeDetail?activityId=${param}&current=${this.formListRecord.current}&size=${this.formListRecord.size}&endTime=${this.formListRecord.endTime?this.formListRecord.endTime:''}&startTime=${this.formListRecord.startTime?this.formListRecord.startTime:''}&prizeType=${this.formListRecord.prizeType?this.formListRecord.prizeType:''}&status=${this.formListRecord.status?this.formListRecord.status:''}&memberNick=${this.formListRecord.memberNick?this.formListRecord.memberNick:''}&pin=${this.formListRecord.pin?this.formListRecord.pin:""}`;
        // elem.href = url;
        // document.body.appendChild(elem);
        // elem.click();
        // document.body.removeChild(elem);
      } else {
        //更改为post（blob）请求
        let param = this.formList.activityId;
        exportPointActivityPrizeDetail({
          activityId: encodeURI(param),
          current: formDate.current,
          size: formDate.size,
          startTime: formDate.startTime || "",
          endTime: formDate.endTime || "",
          prizeType: formDate.prizeType || "",
          status: formDate.status || "",
          memberNick: formDate.memberNick || "",
          orderState: formDate.orderState || "",
          unlockOrderId: formDate.unlockOrderId || "",
          pin: formDate.pin || "",
          code: typeof code === "string" ? code : undefined,
        }).then((res) => {
          if (res.code == 1) {
            this.createAndDownload(res);
          } else {
            this.$message.warning(res.message);
          }
        });
        // let elem = document.createElement("a");
        // elem.style.display = "none";
        // let url = `/jd-hd-web/PointActivityEffectDetails/exportPointActivityPrizeDetail?activityId=${encodeURI(param)}&current=${formDate.current}&size=${formDate.size}&endTime=${formDate.endTime?formDate.endTime:''}&startTime=${formDate.startTime?formDate.startTime:''}&prizeType=${formDate.prizeType?formDate.prizeType:''}&status=${formDate.status?formDate.status:''}&memberNick=${formDate.memberNick?formDate.memberNick:''}&orderState=${formDate.orderState?formDate.orderState:''}&unlockOrderId=${formDate.unlockOrderId?formDate.unlockOrderId:""}&pin=${formDate.pin?formDate.pin:""}`;
        // elem.href = url;
        // document.body.appendChild(elem);
        // elem.click();
        // document.body.removeChild(elem);
      }
    },
    //实物奖品
    inKingRecord() {
      this.loading = true;
      // console.log(this.formList);
      console.log(this.formList);
      inKindList(this.formList)
        .then((res) => {
          this.loading = false;
          // this.userInfoTable = res.data.records;
          this.totalInkind = Number(res.data.total);
          let records = res.data.records;
          this.inkindTable = records.map((item) => {
            item.prizeTitle = item.prizeTitle || item.title;
            return {
              ...item,
              // id:item.recordId
            };
          });
          // // console.log(res.data.records);
          // this.totalSignIn = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //资料明细
    improveRecord() {
      this.loading = true;
      // this.formList.startTime = "2010-01-01 00:00:00";
      // this.formList.endTime = "2030-01-01 00:00:00";
      improveList(this.formList)
        .then((res) => {
          this.loading = false;
          this.userInfoTable = res.data.records;
          this.totalUserInfo = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //标记状态
    markIss(row) {
      signIssuance({ id: row.recordId || row.id })
        .then((res) => {
          if (res && res.code == 1) {
            if (this.tabName == "twenty-one") {
              // 打榜有礼的
              this.getWinRecord();
            } else {
              this.winningRecord();
              this.inKingRecord();
            }
            this.$message.success(res.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => {});
    },
    // 抽奖机会赠送
    commentDraw() {
      this.loading = true;
      commentDraw(this.formList)
        .then((res) => {
          this.loading = false;
          this.CommentList = res.data.records;
          this.totalComment = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 拼券明细
    CoupondDtails() {
      this.loading = true;

      if (this.fitersChooseIF([21])) {
        getSplitCouponlist(this.formList).then((res) => {
          this.loading = false;
          this.couponDetailsList = res.data.records;
          this.totalCoupon = Number(res.data.total);
        });
      } else {
        splitCouponPage(this.formList).then((res) => {
          this.loading = false;
          this.couponDetailsList = res.data.records;
          this.totalCoupon = Number(res.data.total);
        });
      }
    },
    // 优惠券统计
    CouponStatistics() {
      this.loading = true;
      if (this.fitersChooseIF([21])) {
        getStatisticsCouponlist(this.formList).then((res) => {
          this.loading = false;
          this.CouponStatisticsList = res.data.records.map((item, index) => {
            let obj = item;
            obj.id = index + "@10";
            let num = index++;
            if (obj.data.length != 0) {
              obj.data.forEach((ele, i) => {
                ele.id = num + new Date();
              });
            }
            return obj;
          });
          this.totalCouponstatistics = Number(res.data.total);
        });
      } else {
        splitCouponStatistics(this.formList).then((res) => {
          this.loading = false;
          this.CouponStatisticsList = res.data.map((item, index) => {
            let obj = item;
            obj.id = index + "@1@";
            return obj;
          });
        });
      }
    },
    // 团队详情
    TeamDetails() {
      this.loading = true;
      if (this.fitersChooseIF([31])) {
        splitCouponGroup(this.formList).then((res) => {
          this.loading = false;
          this.TeamDetailsList = res.data.records;
          this.totalTeam = Number(res.data.total);
        });
      } else {
        CouponDetail(this.formList).then((res) => {
          this.loading = false;
          this.TeamDetailsList = res.data.records;
          this.totalTeam = Number(res.data.total);
        });
      }
    },
    //分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.queryTotal();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.queryTotal();
    },
    handleSizeSignIn(val) {
      this.formList.size = val;
      this.checkRecord();
    },
    handleCurrentSignIn(val) {
      this.formList.current = val;
      this.checkRecord();
    },
    handleSizeAddCart(val) {
      this.formList.size = val;
      this.addCartpage();
    },
    handleCurrentAddCart(val) {
      this.formList.current = val;
      this.addCartpage();
    },
    handleSizeLockRight(val) {
      this.formList.size = val;
      this.lockRightRecord();
    },
    handleCurrentLockRight(val) {
      this.formList.current = val;
      this.lockRightRecord();
    },
    handleSizeTakeGoods(val) {
      this.formList.size = val;
      this.takeGoodsRecord();
    },
    handleCurrentTakeGoods(val) {
      this.formList.current = val;
      this.takeGoodsRecord();
    },
    // 参与记录
    handleSizeParticipat(val) {
      this.formList.size = val;
      this.getParticipation();
    },
    handleCurrentParticipat(val) {
      this.formList.current = val;
      this.getParticipation();
    },
    handleSizeAward(val) {
      this.formList.size = val;
      this.winningRecord();
    },
    handleSizeAward1(val) {
      this.formList.size = val;
      this.statistics();
    },
    handleSizeAwardOne(val) {
      this.formList.size = val;
      this.distributionRecord();
    },
    handleCurrentAward(val) {
      this.formList.current = val;
      this.winningRecord();
    },
    handleCurrentAward1(val) {
      this.formList.current = val;
      this.statistics();
    },
    handleCurrentAwardOne(val) {
      this.formList.current = val;
      this.distributionRecord();
    },
    handleSizeInkind(val) {
      this.formList.size = val;
      this.inKingRecord();
    },
    handleCurrentInkind(val) {
      this.formList.current = val;
      this.inKingRecord();
    },
    handleSizeUserInfo(val) {
      this.formList.size = val;
      this.improveRecord();
    },
    handleCurrentUserInfo(val) {
      this.formList.current = val;
      this.improveRecord();
    },
    // 抽奖机会赠送
    handleSizeComment(val) {
      this.formList.size = val;
      this.commentDraw();
    },
    handleCurrentComment(val) {
      this.formList.current = val;
      this.commentDraw();
    },
    // 拼券明细
    handleSizeCoupond(val) {
      this.formList.size = val;
      this.CoupondDtails();
    },
    handleCurrentCoupond(val) {
      this.formList.current = val;
      this.CoupondDtails();
    },
    // 优惠券统计
    handleSizeCouponStatistics(val) {
      this.formList.size = val;
      this.CouponStatistics();
    },
    handleCurrentCouponStatistics(val) {
      this.formList.current = val;
      this.CouponStatistics();
    },
    // 团队详情
    handleSizeTeam(val) {
      this.formList.size = val;
      this.TeamDetails();
    },
    handleCurrentTeam(val) {
      this.formList.current = val;
      this.TeamDetails();
    },
    // 赠送记录
    handleSizeGiftrecord(val) {
      this.formList.size = val;
      this.getGameTaskRecord();
    },
    handleCurrentGiftrecord(val) {
      this.formList.current = val;
      this.getGameTaskRecord();
    },
    //签到查询
    searchForm(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin || "";
      this.formList.memberNick = val.memberNick || "";
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.checkRecord();
    },
    // 加购记录查询
    searchAddCart(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.isWin = val.isWin;
      this.addCartpage();
    },
    //参与记录查询
    searchParticipationForm(val) {
      // console.log(val);
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.startScore = val.startScore;
      this.formList.endScore = val.endScore;
      this.formList.isPass = val.isPass;
      this.formList.isDraw = val.isDraw;
      this.formList.isWin = val.isWin;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.getParticipation();
    },
    searchAward(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";

      this.distributionRecord();
    },
    // 派样下单记录查询方法
    searchSendBuyPay(val) {
      console.log("val", val);
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.skuId = val.skuId;
      this.formList.skuName = val.skuName;
      this.formList.orderId = val.orderId;
      this.formList.isCommitAddress = val.isCommitAddress;
      this.formList.orderTimeStart = val.orderTimeStart;
      this.formList.orderTimeEnd = val.orderTimeEnd;
      this.formList.receiveTimeStart = val.receiveTimeStart;
      this.formList.receiveTimeEnd = val.receiveTimeEnd;
      console.log("formList", this.formList);
      this.getSendBuyPayData();
    },

    // 派样下单记录列表查询方法
    getSendBuyPayData() {
      this.loading = true;
      this.formList.id = this.formList.activityId;
      // 派样传type 为 0
      let params = {
        ...this.formList,
        type: 0,
      };
      // 发送请求
      getOrderRecordPage(params)
        .then((res) => {
          this.sendBuyPayTable = [];
          if (res.code == 1) {
            this.sendBuyPayTable = res.data.records;
            this.totalSendBuyPayCount = Number(res.data.total);
            this.formList.current = Number(res.data.current);
            this.loading = false;
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    handleCurrentSendBuyPay(val) {
      this.formList.current = val;
      this.getSendBuyPayData();
    },
    handleSizeSendBuyPay(val) {
      this.formList.size = val;
      this.getSendBuyPayData();
    },
    //随单发
    handleCurrentSendBuyPayRandom(val) {
      this.formList.current = val;
      this.getSendBuyPayDataRandom();
    },
    handleSizeSendBuyPayRandom(val) {
      this.formList.size = val;
      this.getSendBuyPayDataRandom();
    },

    handleCurrentSendBuyRePayRandom(val) {
      this.formList.current = val;
      this.getSendBuyRePayDataRandom();
    },
    handleSizeSendBuyRePayRandom(val) {
      this.formList.size = val;
      this.getSendBuyRePayDataRandom();
    },

    //随单发付款列表
    searchSendBuyPayRandom(val) {
      console.log("val", val);
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.skuId = val.skuId;
      this.formList.skuName = val.skuName;
      this.formList.orderId = val.orderId;
      this.formList.paymentConfirmTimeStart = val.paymentConfirmTimeStart;
      this.formList.paymentConfirmTimeEnd = val.paymentConfirmTimeEnd;
      this.formList.orderStateRemark = val.orderStateRemark;
      this.formList.orderEndTimeStart = val.orderEndTimeStart;
      this.formList.orderEndTimeEnd = val.orderEndTimeEnd;
      this.getSendBuyPayDataRandom();
    },

    //随单回购付款列表
    searchSendBuyRePayRandom(val) {
      console.log("val", val);
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.skuId = val.skuId;
      this.formList.skuName = val.skuName;
      this.formList.orderId = val.orderId;
      this.formList.paymentConfirmTimeStart = val.paymentConfirmTimeStart;
      this.formList.paymentConfirmTimeEnd = val.paymentConfirmTimeEnd;
      this.formList.orderStateRemark = val.orderStateRemark;
      this.formList.orderEndTimeStart = val.orderEndTimeStart;
      this.formList.orderEndTimeEnd = val.orderEndTimeEnd;
      this.formList.orderStartTimeStart = val.orderStartTimeStart;
      this.formList.orderStartTimeEnd = val.orderStartTimeEnd;
      this.getSendBuyRePayDataRandom();
    },

    getSendBuyPayDataRandom() {
      this.loading = true;
      this.formList.id = this.formList.activityId;
      // 派样传type 为 0
      let params = {
        ...this.formList,
        orderType: 0,
      };
      // 发送请求
      promoPage(params)
        .then((res) => {
          this.sendBuyPayTableRandom = [];
          if (res.code == 1) {
            this.sendBuyPayTableRandom = res.data.records;
            this.totalSendBuyPayCountRandom = Number(res.data.total);
            this.formList.current = Number(res.data.current);
            this.loading = false;
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    getSendBuyRePayDataRandom() {
      this.loading = true;
      this.formList.id = this.formList.activityId;
      // 派样传type 为 0
      let params = {
        ...this.formList,
        orderType: 1,
      };
      // 发送请求
      promoPage(params)
        .then((res) => {
          this.sendBuyRePayTableRandom = [];
          if (res.code == 1) {
            this.sendBuyRePayTableRandom = res.data.records;
            this.totalSendBuyRePayCountRandom = Number(res.data.total);
            this.formList.current = Number(res.data.current);
            this.loading = false;
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },

    // 回购下单记录查询方法
    searchSendBuyRePay(val) {
      // console.log("val", val);
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.skuId = val.skuId;
      this.formList.skuName = val.skuName;
      this.formList.orderId = val.orderId;
      this.formList.orderPaymentStart = val.orderPaymentStart;
      this.formList.orderPaymentEnd = val.orderPaymentEnd;
      this.formList.isWin = val.isWin;
      this.formList.isCommitAddress = val.isCommitAddress;
      this.formList.orderTimeStart = val.orderTimeStart;
      this.formList.orderTimeEnd = val.orderTimeEnd;
      this.formList.receiveTimeStart = val.receiveTimeStart;
      this.formList.receiveTimeEnd = val.receiveTimeEnd;
      console.log("formList", this.formList);
      this.getSendBuyRePayData();
    },

    // 令牌查询
    searchSendToken(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.sendStatus = val.sendStatus;
      this.formList.sendTimeStart = val.sendTimeStart;
      this.formList.sendTimeEnd = val.sendTimeEnd;
      this.formList.tokenId = val.tokenId;
      this.formList.useTimesStart = val.useTimesStart;
      this.formList.useTimesEnd = val.useTimesEnd;
      this.getSendToken();
    },
    //派样回购对标商品
    searchSendTokenOne(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.isHaveGive = val.isHaveGive;
      this.getSendTokenOne();
    },
    getSendToken() {
      this.loading = true;
      this.formList.id = this.formList.activityId;
      let params = {
        ...this.formList,
      };
      // 发送请求
      promoPageToken(params)
        .then((res) => {
          this.sendToken = [];
          if (res.code == 1) {
            this.sendToken = res.data.records;
            this.totalSendBuyRePayCountToken = Number(res.data.total);
            this.formList.current = Number(res.data.current);
            this.formList.size = Number(res.data.size);
            this.loading = false;
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    //派样回购对标商品
    getSendTokenOne() {
      this.loading = true;
      this.formList.id = this.formList.activityId;
      let params = {
        ...this.formList,
      };
      // 发送请求
      benchmarking(params)
        .then((res) => {
          this.sendTokenOne = [];
          if (res.code == 1) {
            this.sendTokenOne = res.data.records;
            this.totalSendBuyRePayCountTokenOne = Number(res.data.total);
            this.formList.current = Number(res.data.current);
            this.formList.size = Number(res.data.size);
            this.loading = false;
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    // 回购下单记录列表查询方法
    getSendBuyRePayData() {
      this.loading = true;
      this.formList.id = this.formList.activityId;
      // 复购传type 为 1
      let params = {
        ...this.formList,
        type: 1,
      };
      // 发送请求
      getOrderRecordPage(params)
        .then((res) => {
          this.sendBuyRePayTable = [];
          if (res.code == 1) {
            this.sendBuyRePayTable = res.data.records;
            this.totalSendBuyRePayCount = Number(res.data.total);
            this.formList.current = Number(res.data.current);
            this.formList.size = Number(res.data.size);
            this.loading = false;
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    handleCurrentSendBuyRePay(val) {
      this.formList.current = val;
      this.getSendBuyRePayData();
    },
    handleSizeSendBuyRePay(val) {
      this.formList.size = val;
      this.getSendBuyRePayData();
    },
    handleSizeSendBuyRePayToken(val) {
      this.formList.current = val;
      this.getSendToken();
    },
    handleCurrentSendBuyRePayToken(val) {
      this.formList.size = val;
      this.getSendToken();
    },
    handleSizeSendBuyRePayTokenOne(val) {
      this.formList.current = val;
      this.getSendTokenOne();
    },
    handleCurrentSendBuyRePayTokenOne(val) {
      this.formList.size = val;
      this.getSendTokenOne();
    },
    // 下单有礼 解锁成功记录
    searchUnlock(val) {
      console.log("val", val);
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.checkStartTime = val.checkStartTime;
      this.formList.checkEndTime = val.checkEndTime;
      this.formList.unlockOrderId = val.unlockOrderId;

      console.log("formList", this.formList);
      this.getUnlockRecord();
    },
    getUnlockRecord() {
      this.loading = true;
      this.formList.id = this.formList.activityId;
      // 确保传递sellerLinkId参数
      const params = {
        ...this.formList,
        isUnLockOrder: true
      };
      getUnlockRecord(params).then((res) => {
        this.totalAward = 0;
        this.UnlockTable = [];
        if (res.code == 1) {
          this.UnlockTable = res.data.records;
          this.totalAward = Number(res.data.total);
          this.formList.current = Number(res.data.current);
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 导出
    UnlockExport() {
      // this.formList.id = this.formList.activityId;
      exportCheckOrderDetail(this.formList).then((res) => {
        if (res) {
          var blob = new Blob([res]);
          var link = document.createElement("a"); //a标签下载
          link.href = window.URL.createObjectURL(blob);
          link.download = "解锁成功记录.xls";
          link.click();
          // window.URL.revokeObjectURL(link.href);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 打榜有礼 领奖记录 查询方法
    searchAwardFifteen(val) {
      console.log("val", val);
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.rank = val.rank;
      this.formList.prizeType = val.prizeType;
      this.formList.status = val.status;
      this.formList.createTimeStart = val.createTimeStart;
      this.formList.createTimeEnd = val.createTimeEnd;
      this.formList.sendTimeStart = val.sendTimeStart;
      this.formList.sendTimeEnd = val.sendTimeEnd;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      console.log("formList", this.formList);
      this.getWinRecord();
    },
    getWinRecord() {
      this.loading = true;
      this.formList.id = this.formList.activityId;
      getWinRecordPage(this.formList).then((res) => {
        this.totalAward = 0;
        this.activityTable = [];
        if (res.code == 1) {
          this.activityTable = res.data.records;
          this.totalAward = Number(res.data.total);
          this.formList.current = Number(res.data.current);
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 打榜有礼 实物奖品 查询方法
    searchGoodRecordsPage(val) {
      console.log("val", val);
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.deliveryTimeStart = val.deliveryTimeStart
        ? val.deliveryTimeStart
        : "";
      this.formList.deliveryTimeEnd = val.deliveryTimeEnd
        ? val.deliveryTimeEnd
        : "";
      this.formList.sendTimeStart = val.sendTimeStart ? val.sendTimeStart : "";
      this.formList.sendTimeEnd = val.sendTimeEnd ? val.sendTimeEnd : "";
      this.formList.commitAddressFlag = val.commitAddressFlag;
      if (this.rowData.activityType == 39) {
        this.formList.status = val.status;
      } else {
        this.formList.prizeStatus = val.prizeStatus;
      }
      this.getGoodsRecord();
    },
    getGoodsRecord() {
      this.loading = true;

      let fn = getGoodsRecordPage;
      if (this.rowData.activityType == 39) {
        fn = goodRecords;
      }
      fn(this.formList).then((res) => {
        this.totalAward = 0;
        this.goodsRecordTable = [];
        if (res.code == 1) {
          let tableData = res.data.records;
          this.goodsRecordTable = tableData;
          this.totalAward = Number(res.data.total);
          this.formList.current = Number(res.data.current);
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 打榜有礼实物切换size
    handleGoodsRecordSize(val) {
      this.formList.size = val;
      this.getGoodsRecord();
    },
    // 打榜有礼实物切换current
    handleGoodsRecordCurrent(val) {
      this.formList.current = val;
      this.getGoodsRecord();
    },
    // 打榜有礼领奖记录切换size
    handleFifteenWinRecordSize(val) {
      this.formList.size = val;
      this.getWinRecord();
    },
    // 打榜有礼领奖记录切换current
    handleFifteenWinCurrent(val) {
      this.formList.current = val;
      this.getWinRecord();
    },

    // 打榜有礼领奖记录切换size
    handleUnlockRecordSize(val) {
      this.formList.size = val;
      this.getUnlockRecord();
    },
    // 打榜有礼领奖记录切换current
    handleUnlockWinCurrent(val) {
      this.formList.current = val;
      this.getUnlockRecord();
    },
    //发放记录
    searchAwardOne(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.unlockOrderId = val.unlockOrderId;
      this.formList.orderState = val.orderState;
      this.formList.isFillAddress = val.isFillAddress;
      // 下单抽奖-添加白名单字段
      if (this.rowData.activityType == 19) {
        this.formList.isWhite = val.isWhite;
      }
      this.winningRecord();
    },
    // 中奖记录 积分锁权 - 派样回购礼
    searchAwardFour(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.mobile = val.mobile;
      this.formList.sendStatus = val.sendStatus;
      this.formList.deliveryStatus = val.deliveryStatus;
      this.formList.createTimeStart = val.createTimeStart;
      this.formList.createTimeEnd = val.createTimeEnd;
      this.formList.sendTimeStart = val.sendTimeStart;
      this.formList.sendTimeEnd = val.sendTimeEnd;
      this.formList.deliveryTimeStart = val.deliveryTimeStart;
      this.formList.deliveryTimeEnd = val.deliveryTimeEnd;

      this.winningRecord();
    },
    //锁权记录
    searchLockRight(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.isPass = val.isPass;
      this.formList.isEnter = val.isEnter;
      this.formList.buyOrderNumMin = val.buyOrderNumMin;
      this.formList.buyOrderNumMax = val.buyOrderNumMax;
      this.formList.buyMoneyMin = val.buyMoneyMin;
      this.formList.buyMoneyMax = val.buyMoneyMax;
      this.formList.createTimeStart = val.createTimeStart;
      this.formList.createTimeEnd = val.createTimeEnd;
      this.lockRightRecord();
    },
    searchTakeGoods(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.inputTimeStart = val.inputTimeStart;
      this.formList.inputTimeEnd = val.inputTimeEnd;
      this.takeGoodsRecord();
    },
    searchInkind(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick ? val.memberNick : "";
      this.formList.startTime = val.startTime ? val.startTime : "";
      this.formList.endTime = val.endTime ? val.endTime : "";
      this.formList.status = val.status ? val.status : "";
      this.formList.orderId = val.orderId ? val.orderId : "";
      this.formList.orderState = val.orderState ? val.orderState : "";
      this.formList.commitAddressFlag = val.commitAddressFlag;
      this.formList.prizeStatus = val.prizeStatus ? val.prizeStatus : "";
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.inKingRecord();
    },
    searchUserInfo(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.pin = val.pin;
      this.improveRecord();
    },
    searchComment(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.orderId = val.orderId;
      this.formList.nickName = val.nickName;
      this.formList.filterType = val.filterType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.commentDraw();
    },
    searchCoupon(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.CoupondDtails();
    },
    searchSplit(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.startTime = val.startTime
        ? val.startTime + " 00:00:00"
        : "";
      this.formList.endTime = val.endTime ? val.endTime + " 23:59:59" : "";
      this.CouponStatistics();
    },
    searchGroup(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.startTime = val.startTime
        ? val.startTime + " 00:00:00"
        : "";
      this.formList.endTime = val.endTime ? val.endTime + " 23:59:59" : "";
      if (this.fitersChooseIF([31])) {
        this.formList.status = val.status;
      }
      this.TeamDetails();
    },
    // 赠送记录
    searchGiftrecord(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.taskType = val.taskType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.getGameTaskRecord();
    },
    //邀请统计
    searchAwardStatistics(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.unlockOrderId = val.unlockOrderId;
      this.formList.orderState = val.orderState;
      this.formList.isFillAddress = val.isFillAddress;
      this.statistics();
    },
    //Note----邀请统计
    // 被邀请人明细
    inviteeDetailsSearch(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.invitePin = val.invitePin;
      this.formList.inviteNick = val.inviteNick;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.isValidInvite = val.isValidInvite;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.toGetInviteDetail();
    },
    toGetInviteDetail() {
      getInviteDetail(this.formList).then((res) => {
        this.loading = false;
        this.inviteeDetailsData = res.data.records;
        this.inviteeDetailsTotal = Number(res.data.total);
      });
    },
    handleCurrentInviteDetail(val) {
      this.formList.current = val;
      this.toGetInviteDetail();
    },
    handleSizeInviteDetail(val) {
      this.formList.size = val;
      this.toGetInviteDetail();
    },
    statistics() {
      this.loading = true;
      // 只有邀请类的调awardRecNew接口
      if (this.rowData.activityType == 5 || this.rowData.activityType == 6) {
        invaidStatics(this.formList)
          .then((res) => {
            this.loading = false;
            this.invitationNum = res.data.records;
            this.totalAwardFor = Number(res.data.total);
          })
          .catch((res) => {});
        searchInvite({ id: this.rowData.id }).then((res) => {
          this.isTaskPrize = res.data.ruleDto.isTaskPrize;
        });
      }
    },
    // 兑换记录
    getList() {
      this.loading = true;
      // if (this.opentime == true) {
      //   this.formDataList.startTime = this.mytimestart;
      //   this.formDataList.endTime = this.mytimeend;
      //   this.opentime = false;
      // }
      getExchangeActivityRecord(this.formList).then((res) => {
        this.exchangeList = res.data.records;
        this.loading = false;
        this.totalMail = Number(res.data.total);
      });
    },
    //标记发货
    changeShip(row) {
      // let id = row.id;
      console.log(row);
      this.$confirm("是否标记为发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        DeliveryStatus(row.id, 1)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success(res.message);
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      });
    },
    // 取消发货
    cancelShip(row) {
      this.$confirm("是否取消发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        DeliveryStatus(row.id, 1)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success("取消发货成功");
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      });
    },
    // 兑换记录表单查询
    searchFormThir(val) {
      this.formList = { ...val, activityId: this.rowData.id };
      this.formList.size = 10;
      this.formList.current = 1;
      this.getList();
    },
    //分页事件
    handleSizeExchange(val) {
      this.formList.size = val;
      this.getList();
    },
    handleCurrentExchange(val) {
      this.formList.current = val;
      this.getList();
    },

    // 领取记录列表
    getRecord() {
      this.loading = true;
      const query = {
        size: this.formListRecord.size,
        current: this.formListRecord.current,
        activityId: this.rowData.id,
      };
      if (this.formListRecord.memberNick) {
        query.memberNick = this.formListRecord.memberNick;
      }
      if (this.formListRecord.prizeType) {
        query.prizeType = this.formListRecord.prizeType;
      }
      if (this.formListRecord.status) {
        query.status = this.formListRecord.status;
      }
      if (this.formListRecord.startTime && this.formListRecord.endTime) {
        query.startTime = this.formListRecord.startTime;
        query.endTime = this.formListRecord.endTime;
      }
      getUnlockRecord(query).then((res) => {
        if (res.code == 1) {
          this.getRecordList = res.data.records;
          this.totalRecord = Number(res.data.total);
          this.formListRecord.current = Number(res.data.current);
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 领取记录表单
    searchFormRecord(val) {
      this.formListRecord = { ...val, activityId: this.rowData.id };
      this.formListRecord.size = 10;
      this.formListRecord.current = 1;
      this.getRecord();
    },
    //分页事件
    handleSizeExchangeRecord(val) {
      this.formListRecord.size = val;
      this.getRecord();
    },
    handleCurrentExchangeRecord(val) {
      this.formListRecord.current = val;
      this.getRecord();
    },
    // 领取记录标记发放
    recordMark(row) {
      signIssuance({ id: row.recordId || row.id })
        .then((res) => {
          if (res && res.code == 1) {
            this.getRecord();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => {});
    },
    //邀请明细分页
    handleSizeExchangeStatics(val) {
      this.formList1.size = val;
      this.invitationDetailNews();
    },
    handleCurrentExchangeStatics(val) {
      this.formList1.current = val;
      this.invitationDetailNews();
    },
    // 点击解密  name: 修改的字段名   objdata：数组的名称, params:接口的参数  item：点击的对象    index：数组传下标值
    handleDecrypt(name, objdata, item, index) {
      let params = "";
      // 资料明细 userInfoTable  实物奖品 inkindTable
      if (objdata == "userInfoTable") {
        params =
          "encrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      } else if (objdata == "inkindTable" || objdata == "awardTable") {
        params =
          "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      } else {
        params =
          "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      }
      this.$decrypt
        .decrypt({ decryptContent: item[`${params}`] })
        .then((res) => {
          this[`${objdata}`][index][`${name}`] = res.message;
        });
    },

    // 点击解密
    handleDecrypt1(name, item, index) {
      let params =
        "encrypt" + name[0].toUpperCase() + name.substring(1, name.length);

      this.$decrypt
        .decrypt({ decryptContent: item[`${params}`] })
        .then((res) => {
          this.exchangeList[index][`${name}`] = res.message;
        });
    },

    // 折线图 tooltip
    //echarts图表自定义提示框函数
    echartIcon(params) {
      var str =
        '<div style="font-size:13px;color:#fff;font-weight:500;line-height:1;">' +
        params[0].name +
        "</div>";
      params.forEach((item) => {
        let value = item.value;
        let seriesName = item.seriesName;
        if (!item.value) {
          value = 0;
        }
        if (this.fitersChooseIF([25, 33, 32, 26])) {
          let dataList = [
            "点击用户下单转化率",
            "访客加购率",
            "点击率",
            "下单-支付转化率",
            "访客成交转化率",
          ];
          if (dataList.includes(seriesName)) {
            value = value * 100 + "%";
          }
        }
        if (this.fitersChooseIF([37])) {
          let dataList = ["收货回购率", "付款回购率"];
          if (dataList.includes(seriesName)) {
            value = value + "%";
          }
        }
        str += `<div style="font-size:13px;color::#fff;"><span style="display:inline-block;margin-right:8px;border-radius:20px;width:10px;height:10px;background-color:${item.color};"></span><span style="margin-right:4px">${seriesName}：</span><span style="font-weight:400">${value}</span></div>`;
      });
      return str;
    },
  },
};
